import { Button } from '@mosanic/fields/Button/Buttons';
import { AdvancedLabel, ControlDialog } from '@mosanic/items';
import React, { useContext, useState } from 'react';
// import 'tui-image-editor/dist/tui-image-editor.css';
import CoreContext from '@context/CoreContext';
import { SuccessAlert } from '../../../components/Core/Utils';
import { ErrorAlert } from '../../../components/Core/Utils/ErrorAlert';
import MediaUploader from './MediaUploader';






// import ImageEditor from '@toast-ui/react -image-editor';

const ImageEditor = null;

	const lightTheme = {
            'menu.normalIcon.color': '#222',
            'menu.activeIcon.color': '#1976d2',
            'menu.disabledIcon.color': '#434343',
            'menu.hoverIcon.color': '#1976d2',
			'menu.backgroundColor': '#f4f7fa',
			'submenu.backgroundColor': '#f4f7fa',
            'submenu.normalIcon.color': '#444141',
            'submenu.activeIcon.color': '#1976d2',
			'common.bi.image': 'https://uicdn.toast.com/toastui/img/tui-image-editor-bi.png',
			'common.backgroundImage': './img/bg.png',
			'common.backgroundColor': '#fff',
  			'common.border': 'none',
         };

export const MediaEditor = () => {

	const coreContext = useContext(CoreContext);

	const [error, setError] = useState(null);
    const [msg, setMsg] = useState(null);




	let editorRef = React.createRef();

	const handleClickButton = () => {
		const editorInstance = editorRef.current.getInstance();

		editorInstance.flipX();
	};

	const [modalStateManager, setModalStateManager] = useState(false);
	return (
		<>
		<div >
			<Button onClick={() => setModalStateManager(true)} size="small" variant="outlined">
				Upload media  
			</Button>  
			
				
				<ControlDialog state={modalStateManager} close={() => setModalStateManager(false)} size="xl" fullWidth={true}> 
					<AdvancedLabel helpText="From here you can view, load and open your pages.">
						Upload item 
					</AdvancedLabel>
					
				
					<MediaUploader showEditor maxNumber={3}/>
					
					<Button onClick={() => setModalStateManager(false)} size="small" >
						Close 
					</Button>
				</ControlDialog>
				
				
				<div className="DataList-alerts">
					
					{error && <ErrorAlert errorMessage={error} />}
					{msg && <SuccessAlert successMessage={msg} />}

				</div>	

		</div>	
		
		</>
	);
};